// Module
var code = "<div layout=\"column\" layout-align=\"center center\" class=\"full-height\"> <empty-state src=\"assets/images/empty_state/empty_state_dispatching.png\" text=\"There are no depots found for this site, please create the first depot to continue\" action=\"'Go to depots page'\" on-action=\"$ctrl.onAction()\"> </empty-state> </div> ";
// Exports
export default code;